import { Box, CardMedia, Typography } from "@mui/material";
import DownArrow from "assets/Icons/downArrow.svg";
import { ReactComponent as GreaterThan } from "assets/Icons/GreaterThan.svg";
import HandMobile from "assets/Icons/handMobile.svg";
import UpArrow from "assets/Icons/upArrow.svg";
import React from "react";

const data = [
  {
    id: 1,
    icon: HandMobile,
    title: "45,00,000 +",
    subtitle: "Requests supported",
  },
  {
    id: 2,
    icon: DownArrow,
    title: "80%",
    subtitle: "Cost of Service",
  },
  {
    id: 3,
    icon: UpArrow,
    title: "20%",
    subtitle: "User Retention",
  },
];

function Stats() {
  return (
    <Box
      sx={{
        border: "1px solid black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row", md: "row" },
        gap: "32px",
        padding: "20px",
      }}
    >
      {data.map((item) => (
        <Box
          key={item.id}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "200px",
            border: "4.159px solid #FFF",
            background: "#C1DFEB",
            boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
            gap: { xs: "24px", sm: "24px", md: "24px" },
            height: { xs: "64px", sm: "", md: "94px" },
            padding: { xs: "", sm: "", md: "20px" },
            width: { xs: "228px" },
          }}
        >
          <Box
            sx={{
              width: { xs: "36px", sm: "45px", md: "56px" },
              height: { xs: "36px", sm: "45px", md: "56px" },
              border: "1px solid red",
            }}
          >
            <CardMedia
              component="img"
              image={item.icon}
              alt={item.id}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <Typography
              sx={{
                color: "#555B5D",
                fontFamily: "Inter",
                fontSize: { xs: "16px", sm: "23px", md: "28px" },
                fontWeight: 600,
                lineHeight: 1.4,
              }}
            >
              {item.title}
            </Typography>
            <Typography
              sx={{
                color: "#555B5D",
                fontFamily: "Inter",
                fontSize: { xs: "13px", sm: "16px", md: "19px" },
                fontWeight: 400,
                lineHeight: 1.4,
              }}
            >
              {item.subtitle}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default Stats;
